import React, { FC } from 'react';
import { t } from '../../../utils/helpers';
import styles from '../styles/invitesBtn.module.scss';

type PropsType = {
  handleShow: React.Dispatch<React.SetStateAction<boolean>>;
  count: number;
  doNotDisturb: boolean;
};

export const InvitesBtn: FC<PropsType> = ({
  handleShow,
  count,
  doNotDisturb,
}: PropsType) => {
  return (
    <div
      className={styles.button}
      onClick={() => {
        handleShow((prevState: boolean) => !prevState);
      }}
    >
      <div className={styles.wrap}>
        <div className={styles.content}>{t('invites')}</div>
        {!!count && <div className={styles.count}>{count}</div>}
      </div>
    </div>
  );
};
